import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { OrderBuilder } from '../components/OrderBuilder/OrderBuilder';
import { ProblemSection } from '../components/ProblemSection';
import { DoorsSection } from '../components/DoorsSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TrustSection } from '../components/TrustSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { LeadForm } from '../components/LeadForm';
import { UrgencySection } from '../components/UrgencySection';
import { DistributorSection } from '../components/DistributorSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCta } from '../components/FinalCta';
import { SiteFooter } from '../components/SiteFooter';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function Landing() {
  return <div className="min-h-screen w-full bg-white" data-id="element-387" data-mp="m8dc0etlugzr">
      <SiteHeader data-id="element-388" data-mp="29s7wh39xkx4" />
      <main data-id="element-389" data-mp="2aadi4bttbhp">
        <Hero data-id="element-390" data-mp="2b38y95c4ekj" />
        <OrderBuilder data-id="element-391" data-mp="2blgw31d0h8a" />
        <ProblemSection data-id="element-392" data-mp="27xoj77ni0v5" />
        <DoorsSection data-id="element-393" data-mp="3tgl5layuz1ww" />
        <BenefitsSection data-id="element-394" data-mp="3tfa45hsvy68y" />
        <TestimonialsSection data-id="element-395" data-mp="3tes224jjkxt4" />
        <TrustSection data-id="element-396" data-mp="3peq7sgg4z6nv" />
        <LeadForm data-id="element-397" data-mp="3pe83qxn8fo5e" />
        <UrgencySection data-id="element-398" data-mp="3pfriukx5jt5l" />
        <DistributorSection data-id="element-399" data-mp="3pf00ibskfrx9" />
        <FaqSection data-id="element-400" data-mp="3kfn2qw05p0fw" />
        <FinalCta data-id="element-401" data-mp="3kg6ic62c3cqr" />
      </main>
      <SiteFooter data-id="element-402" data-mp="3kh7w4iaqidc6" />
      <FloatingWhatsApp data-id="element-403" data-mp="3khq1q5jae3wr" />
    </div>;
}